import {
  isLocalhostHostname,
  isTestHostname,
} from '@storebrand-digital/insurance-common';
import type { F2100Documents, GroupedDocuments, InsuranceDocument } from '.';

export const getInsuranceArchiveTestDocument = (
  policyNumber: string,
): Record<string, InsuranceDocument[]> => {
  return {
    [policyNumber]: [
      {
        documentType: 'LivB-Egen ordning - Forsikringsbevis',
        documentId: '140995547',
        description: 'Forsikringsbevis',
        customerId: '',
        systemName: 'USB',
        date: '2023-06-06',
        hrefToDocument: '/archive/insurance/onbase/140995547',
        policyNumbers: [policyNumber],
      },
    ],
  };
};

export const isTestOrLocalEnvironment = (): boolean =>
  isTestHostname() || isLocalhostHostname();

export function groupF2100DocumentsByPolicyNumber(
  dto: F2100Documents,
): GroupedDocuments {
  if (!dto) {
    return {};
  }

  return dto.reduce<GroupedDocuments>(
    (acc, currentDoc) => {
      const policyNumber = currentDoc.policyNumbers[0];

      if (currentDoc.policyNumbers.length === 0) {
        acc.customerAttached.push(currentDoc);
      } else if (acc[policyNumber]) {
        acc[policyNumber].push(currentDoc);
      } else {
        // eslint-disable-next-line no-param-reassign
        acc[policyNumber] = [currentDoc];
      }

      return acc;
    },
    { customerAttached: [] },
  );
}
